import React from 'react';
// import { FaPencilAlt, FaEraser } from 'react-icons/fa';
import styled, { css } from 'styled-components';
import { normalize } from 'utils';
import { color, media } from 'styles/settings';

const colors = color.linkColors;

const FaPencilAlt = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    />
  </svg>
);

// const FaEraser = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
//     <path fill="none" d="M0 0h24v24H0z" />
//     <path
//       fill="currentColor"
//       d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
//     />
//   </svg>
// );

// const FaEraser = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
//     <path
//       //   fillRule="evenodd"
//       fill="currentColor"
//       d="m38.032 127.602 76.405-78.588c3.074-3.162 9.157-5.737 13.573-5.737h88.392a7.958 7.958 0 0 1 7.966 7.996l-.243 63.237c-.017 4.412-2.563 10.53-5.686 13.655l-74.118 74.176c-3.121 3.124-9.239 5.659-13.66 5.659H40.46c-4.425 0-8.005-3.577-8.005-7.99v-58.682c0-4.414 2.497-10.558 5.577-13.726zM120.002 144h-63.98c-4.405 0-7.997 3.578-7.997 7.993v32.09a7.992 7.992 0 0 0 7.998 7.993h63.98c4.405 0 7.997-3.578 7.997-7.993v-32.09a7.992 7.992 0 0 0-7.998-7.993zm29.638-6.036c-3.115 3.14-5.64 9.268-5.64 13.685v21.72c0 4.418 2.476 5.42 5.542 2.227l53.585-55.823c3.06-3.188 5.542-9.36 5.542-13.771V80.459c0-1.105-.63-1.365-1.41-.578l-57.62 58.083zm-18.046-78.59c-1.66.03-3.966 1-5.143 2.16l-61.065 60.197c-3.146 3.102-2.114 5.616 2.306 5.616h60.119c4.42 0 10.559-2.506 13.71-5.596l63.519-62.277c.788-.773.525-1.384-.577-1.365l-72.869 1.266z"
//     />
//   </svg>
// );
const FaEraser = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path
      fill="currentColor"
      d="m16.24 3.56 4.95 4.94c.78.79.78 2.05 0 2.84L12 20.53a4.008 4.008 0 0 1-5.66 0L2.81 17c-.78-.79-.78-2.05 0-2.84l10.6-10.6c.79-.78 2.05-.78 2.83 0M4.22 15.58l3.54 3.53c.78.79 2.04.79 2.83 0l3.53-3.53-4.95-4.95-4.95 4.95Z"
    />
  </svg>
);

//   export default SvgComponent

export const ToolContext = React.createContext({
  selectedTool: null,
  selectedColor: colors[0],
  setSelectedTool: (t) => {},
  setSelectedColor: (c) => {},
});

// const ToolbarContext = React.createContext();

const ToolbarProvider = ({ children }) => {
  const [selectedColor, setSelectedColor] = React.useState(colors[0]);
  const [selectedTool, setSelectedTool] = React.useState(null);

  const value = {
    selectedColor,
    setSelectedColor,
    selectedTool,
    setSelectedTool,
  };

  return <ToolContext.Provider value={value}>{children}</ToolContext.Provider>;
};

export { ToolbarProvider };

const Toolbar = () => {
  const [isColorDropdownOpen, setIsColorDropdownOpen] = React.useState(false);
  const toolContext = React.useContext(ToolContext);

  const handleColorDropdownToggle = () => {
    setIsColorDropdownOpen(!isColorDropdownOpen);
  };

  const handleColorSelection = (color) => {
    toolContext.setSelectedColor(color);
    setIsColorDropdownOpen(false);
  };
  if (toolContext.selectedTool == null) {
    return null;
  }

  return (
    <Container>
      {/* <ToolbarContainer> */}
      <ToolButton onClick={() => toolContext.setSelectedTool('draw')}>
        <FaPencilAlt
          color={
            toolContext.selectedTool == 'draw' ? color.brand.gold : 'black'
          }
        />
      </ToolButton>
      <ToolButton onClick={() => toolContext.setSelectedTool('erase')}>
        <FaEraser
          color={
            toolContext.selectedTool == 'erase' ? color.brand.gold : 'black'
          }
        />
      </ToolButton>
      <ColorDropdown>
        <ColorButton
          onClick={handleColorDropdownToggle}
          style={{ backgroundColor: toolContext.selectedColor }}
        />
        {isColorDropdownOpen && (
          <ColorOptions>
            {colors.map((color) => (
              <ColorOption
                key={color}
                style={{ backgroundColor: color }}
                onClick={() => handleColorSelection(color)}
              />
            ))}
          </ColorOptions>
        )}
      </ColorDropdown>
      {/* </ToolbarContainer> */}
    </Container>
  );
};

export const Container = styled.div`
  background-color: ${color.neutral.white};
  bottom: ${normalize('20px')};
  display: flex;
  flex-direction: row;
  left: ${normalize('100px')};
  padding: 0 ${normalize('18px')};
  padding-top: ${normalize('18px')};
  padding-bottom: ${normalize('18px')};
  position: fixed;
  z-index: 2;
  ${media.mediaQueries.mobile`
    display:none;
  `}
`;

// const ToolbarContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   background-color: #fff;
//   padding: 8px;
//   border-top-right-radius: 8px;
//   box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);
// `;

const ToolButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  font-size: 24px;
  margin-right: 8px;
  cursor: pointer;

  ${(props) =>
    props.active &&
    css`
      background-color: #eee;
    `}
`;

const ColorDropdown = styled.div`
  position: relative;
`;

const ColorButton = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
`;

const ColorOptions = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

const ColorOption = styled.button`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  margin: 4px;
  cursor: pointer;
`;

export default Toolbar;
